import { Dict } from '../submodules/utils/Types';

interface PreAppInstantiationHook {
    type: 'PreAppInstantiationHook';
    callback: () => Promise<void>;
}

type AllowedHooks = PreAppInstantiationHook;

export abstract class Hooks {
    private static register: Dict<Array<AllowedHooks>> = {};

    public static addHook(hook: AllowedHooks): void {
        if (hook.type == null) {
            throw new Error('Missing hook type. Note: class based hooks must also set the value (type: "Example" = "Example";).');
        }

        if (Hooks.register[hook.type] == null) {
            Hooks.register[hook.type] = [];
        }
        Hooks.register[hook.type].push(hook);
    }

    public static async preAppInstantiationHook(): Promise<void> {
        const hooks: Array<PreAppInstantiationHook> = Hooks.register.PreAppInstantiationHook as Array<PreAppInstantiationHook>;
        if (hooks != null) {
            await Promise.all<void>(
                hooks.map((hook: PreAppInstantiationHook): Promise<void> => {
                    return hook.callback();
                })
            );
        }
    }
}
(window as any).egr.wcf.Hooks = Hooks;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/Hooks.ts